import { render } from "./ResidenceCard.vue?vue&type=template&id=80b75198&scoped=true"
import script from "./ResidenceCard.vue?vue&type=script&lang=js"
export * from "./ResidenceCard.vue?vue&type=script&lang=js"

import "./ResidenceCard.vue?vue&type=style&index=0&id=80b75198&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b75198"]])

export default __exports__